"use client"

import { ConfigProvider, Form, Input, Modal } from "antd"
import clsx from "clsx"
import { useEffect, useRef } from "react"

const BirthdayInputModal = (props) => {
  const { open, onCancel, onOk, confirmLoading } = props
  const dayInputRef = useRef()
  const [birthdayForm] = Form.useForm()

  useEffect(() => {
    if (open) {
      birthdayForm.resetFields()
      setTimeout(() => {
        dayInputRef.current?.focus()
      }, 0)
    }
  }, [open, birthdayForm])

  const handleOk = () => {
    birthdayForm
      .validateFields()
      .then((values) => {
        onOk(`${values.year}-${values.month}-${values.day}`)
      })
      .catch(() => {})
  }

  return (
    <ConfigProvider
      theme={{
        token: {
          borderRadius: 0,
        },
      }}
    >
      <Modal
        open={open}
        width={800}
        footer={null}
        className={clsx(
          "lg_[&_.ant-modal-content]_px-[22px] lg_[&_.ant-modal-content]_py-[60px]",
          "[&_.ant-modal-content]_px-3 [&_.ant-modal-content]_py-8"
        )}
        centered
        onCancel={onCancel}
      >
        <div className="flex flex-col items-center">
          <h2 className="font-poppins text-lg font-normal leading-[30px] text-primary lg_text-xl">
            DATE OF BIRTH
          </h2>
          <div className="mt-4 max-w-[500px] lg_mt-[30px]">
            <ConfigProvider
              theme={{
                token: {
                  borderRadius: 0,
                  colorPrimary: "#2F6132",
                },
              }}
            >
              <Form className="flex gap-x-4" form={birthdayForm}>
                <Form.Item
                  name="month"
                  dependencies={["year"]}
                  className="flex-1 grow"
                  rules={[
                    ({ getFieldValue }) => ({
                      validator(_, month) {
                        return isMonthValid(month, getFieldValue("year"))
                          ? Promise.resolve()
                          : Promise.reject(new Error("month is not valid."))
                      },
                    }),
                  ]}
                >
                  <Input
                    className={clsx(
                      " h-[50px] ",
                      "text-[18px] font-semibold leading-[30px] text-primary"
                    )}
                    placeholder="MM"
                    ref={dayInputRef}
                  />
                </Form.Item>
                <Form.Item
                  name="day"
                  className="flex-1 grow"
                  dependencies={["month", "year"]}
                  rules={[
                    ({ getFieldValue }) => ({
                      validator(_, day) {
                        return isDayValid(
                          day,
                          getFieldValue("month"),
                          getFieldValue("year")
                        )
                          ? Promise.resolve()
                          : Promise.reject(new Error("day is not valid."))
                      },
                    }),
                  ]}
                >
                  <Input
                    className={clsx(
                      " h-[50px] ",
                      "text-[18px] font-semibold leading-[30px] text-primary"
                    )}
                    placeholder="DD"
                  />
                </Form.Item>
                <Form.Item
                  name="year"
                  className="flex-1 grow-[2]"
                  rules={[
                    {
                      validator: (_, year) => {
                        return isYearValid(year)
                          ? Promise.resolve()
                          : Promise.reject(new Error("year is not valid."))
                      },
                    },
                  ]}
                >
                  <Input
                    className={clsx(
                      " h-[50px] ",
                      "text-[18px] font-semibold leading-[30px] text-primary"
                    )}
                    placeholder="YYYY"
                  />
                </Form.Item>
              </Form>
            </ConfigProvider>
          </div>

          <div
            className={clsx(
              "mt-4 flex w-full items-center justify-center lg_mt-[50px]",
              "flex-col sm_flex-row"
            )}
          >
            <button
              className={clsx(
                " h-[50px] w-full lg_h-[60px] lg_w-[200px]",
                "flex items-center justify-center",
                "bg-primary font-poppins text-sm font-normal leading-5 text-white active_scale-[.97] disabled_scale-100 lg_text-base"
              )}
              disabled={confirmLoading}
              onClick={handleOk}
            >
              {confirmLoading ? "CONFIRM..." : "CONFIRM"}
            </button>

            <button
              className={clsx(
                " mt-4  h-[50px] w-full sm_ml-20 sm_mt-0 lg_h-[60px] lg_w-[200px]",
                "flex items-center justify-center",
                " bg-white font-poppins text-sm font-normal leading-5 text-primary active_scale-[.97] lg_text-base",
                "border-2 border-solid border-primary"
              )}
              onClick={onCancel}
            >
              CANCEL
            </button>
          </div>
        </div>
      </Modal>
    </ConfigProvider>
  )
}

const MONTH_REG = /^0[1-9]$|^1[012]$/
const YEAR_REG = /^\d{4}$/
const DAY_REG = /^0[1-9]$|^[12][0-9]$|^3[01]$/

const isYearValid = (year) => {
  if (!YEAR_REG.test(year)) {
    return false
  }

  const nowYear = new Date().getFullYear()
  const numericYear = parseInt(year)

  if (numericYear > nowYear || numericYear < nowYear - 200) {
    return false
  }

  return true
}

const isMonthValid = (month, year) => {
  if (!MONTH_REG.test(month)) {
    return false
  }

  if (!isYearValid(year)) {
    return true
  }

  const now = new Date()
  const nowYear = now.getFullYear()
  const nowMonth = now.getMonth() + 1

  if (nowYear === parseInt(year) && parseInt(month) > nowMonth) {
    return false
  }

  return true
}

const isDayValid = (day, month, year) => {
  if (!DAY_REG.test(day)) {
    return false
  }

  if (!isMonthValid(month, year) || !isYearValid(year)) {
    return true
  }

  const numericYear = parseInt(year)
  const numericMonth = parseInt(month)
  const maxDay = new Date(numericYear, numericMonth, 0).getDate()

  if (day > maxDay) {
    return false
  }

  const now = new Date()
  const nowYear = now.getFullYear()
  const nowMonth = now.getMonth() + 1
  const nowDay = now.getDate()

  if (nowYear === numericYear && nowMonth === numericMonth && day > nowDay) {
    return false
  }

  return true
}

export default BirthdayInputModal
